import { RegionKeys } from 'src/core/provider/AppMeta';
import { fromJsonArray } from 'src/core/utils';
import { Money } from './Money';

interface Zone {
    countryIso2List: string[];
    fees: number[];
}

export default class ShippingCostTable {
    public readonly tables: ShippingCost[];

    constructor(json: any) {
        this.tables = fromJsonArray(ShippingCost, json.deliveryTableDto);
    }

    public getSortedTablesByRegion(region: RegionKeys): ShippingCost[] {
        return this.tables.sort((a, b) => {
            if (a.containsZoneWithRegion(region)) return -1;
            else if (b.containsZoneWithRegion(region)) return 1;

            return 0;
        });
    }

    public getFreeShippingCostByRegion(region: RegionKeys): Money | undefined {
        const table = this.getSortedTablesByRegion(region)[0];
        if (table == null) return;
        const zone = table.getSortedZonesByRegion(region)[0];
        if (zone == null) return;
        const index = zone.fees.findIndex(x => x === 0);
        if (index === -1) return;

        return {
            value: table.minCartValue[index],
            currencyIso: table.currencyIso,
        };
    }
}

export class ShippingCost {
    public readonly currencyIso: string;
    public readonly minCartValue: number[];
    public readonly zones: Zone[];
    public readonly key: string;

    constructor(json: any) {
        this.currencyIso = json.currencyIso4217 || json.currencyIso;
        this.minCartValue = json.minCartValue;
        this.zones = json.zones;
        this.key = this.zones.map(z => z.countryIso2List.join('-')).join('_');
    }

    public containsZoneWithRegion(region: RegionKeys): boolean {
        const needle = region.toUpperCase();
        return this.zones.some(zone => zone.countryIso2List.map(c => c.toUpperCase()).includes(needle));
    }

    public getSortedZonesByRegion(region: RegionKeys): Zone[] {
        const needle = region.toUpperCase();

        return this.zones.sort((a, b) => {
            const aa = a.countryIso2List.map(c => c.toUpperCase());
            const bb = b.countryIso2List.map(c => c.toUpperCase());

            // Sort by given region
            if (aa.includes(needle)) return -1;
            else if (bb.includes(needle)) return 1;

            // Sort alphabetically
            return aa[0] < bb[0] ? -1 : 1;
        });
    }
}
